import {
  Button,
  Divider,
  Grid,
  Text,
  NumberController,
} from "@pushpress/shared-components";
import React, { useContext } from "react";
import { Control, useWatch } from "react-hook-form";
import { SwitchPlanForm, getBillingIntervalType } from "./SwitchPlanForm.utils";
import { CurrentUserSubscriptionFragment } from "../SwitchPlanDrawer-generated.hooks";
import { formatToUSD } from "../../../utils/misc";
import { AppContext } from "../../../context/app";
import SectionTitleAndDescription from "./components/SectionTitleAndDescription";
import { getDiscountDescription } from "../../../components/controllers/DiscountSelect/DiscountSelect.utils";

type SetSetupFeeStepProps = {
  control: Control<SwitchPlanForm>;
  goToNextStep: () => void;
  goBack: VoidFunction;
  userSubscription: CurrentUserSubscriptionFragment;
};

function SetSetupFeeStep({
  control,
  goToNextStep,
  goBack,
  userSubscription,
}: SetSetupFeeStepProps) {
  const { client } = useContext(AppContext);
  const newPlan = useWatch({ control: control, name: "newPlan" });
  const discount = useWatch({ control: control, name: "discount" });
  const planPrice = useWatch({ control: control, name: "planPrice" });

  const amount = planPrice ? planPrice?.amount : Number(newPlan?.amount);
  const intervalType = planPrice ? planPrice?.intervalType : newPlan?.intervalType;
  const interval = planPrice ? planPrice?.interval : newPlan?.interval;

  return (
    <>
      <Grid container>
        <SectionTitleAndDescription
          title="Current plan"
          description={`
            ${userSubscription.plan.name} (${formatToUSD(
              userSubscription.amount,
              client.currencyIso,
            )} ${getBillingIntervalType(
              userSubscription.intervalType,
              userSubscription.chargeInterval,
            )})
              `}
        />
        <Grid item xs={12}>
          <Divider vPadding={16} />
        </Grid>
        <SectionTitleAndDescription
          title="New plan"
          description={`
                ${newPlan.name} (${formatToUSD(
                  amount,
                  client.currencyIso,
                )} ${getBillingIntervalType(
                  intervalType,
                  interval,
                )})
              `}
        />
        <Grid item xs={12}>
          <Divider vPadding={16} />
        </Grid>
        {discount && (
          <>
            <SectionTitleAndDescription
              title="Discount"
              description={`
                ${discount.name} (${getDiscountDescription(
                  discount,
                  client.currencyIso,
                )})`}
            />
            <Grid item xs={12}>
              <Divider vPadding={16} />
            </Grid>
          </>
        )}
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          <Text
            variant="heading-5"
            color="wolf-800"
            weight="600"
            className="pb-3"
          >
            Setup fee
          </Text>
          <div data-cy="setup-fee">
            <NumberController
              control={control}
              name="setupFee"
              label="Setup fee"
              hideLabel
              required
              startText="$"
            />
          </div>
        </Grid>
      </Grid>
      <Grid container item xs={12}>
        <Divider vPadding={16} />
      </Grid>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Button buttonType="text" text="Back" onClick={goBack} />
        </Grid>
        <Grid item>
          <Button
            buttonType="secondary"
            text="Next"
            onClick={() => goToNextStep()}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default SetSetupFeeStep;
